import type { ChipId, MineralKind, CreatureKind } from './config';
export type ArtRegion = readonly [number, number, number, number];
export interface AtlasDef { file: string; width: number; height: number; regions: readonly ArtRegion[] }
export const MAGIC_ATLAS:AtlasDef={file:'/assets/mining-magic-vfx.webp',width:512,height:512,regions:Array.from({length:16},(_,i)=>[(i%4)*128,Math.floor(i/4)*128,128,128] as const)};
export const BASE_ATLAS: AtlasDef = { file: '/assets/mining-sprites.webp', width: 1254, height: 1254, regions: [
  [58,208,196,178],[320,118,294,300],[648,160,273,224],[946,113,296,319],
  [20,471,294,297],[336,500,282,263],[678,470,230,310],[968,499,254,269],
  [24,850,274,304],[371,891,203,206],[622,813,282,352],[952,813,282,352],
] };
export const EXTRA_ATLAS: AtlasDef = { file: '/assets/mining-minerals-extra.webp', width: 1774, height: 887, regions: [
  [50,66,335,350],[485,64,364,358],[934,69,353,339],[1369,55,364,367],
  [35,456,380,390],[494,473,338,356],[935,468,346,369],[1360,454,386,392],
] };
export const TOOL_ATLAS: AtlasDef = { file: '/assets/mining-tools-v2.webp', width: 1448, height: 1086, regions: [
  [83,91,256,255],[452,72,202,279],[757,130,344,225],[1189,95,187,252],
  [83,412,226,261],[441,412,193,264],[800,431,219,235],[1134,431,252,235],
  [94,730,205,255],[430,750,256,241],[770,763,325,222],[1184,730,178,271],
] };
export const CREATURE_ATLAS: AtlasDef = {file:'/assets/mining-creatures.webp',width:2172,height:724,regions:[
  [33,159,491,434],[632,201,410,394],[1097,180,456,410],[1594,194,559,387],
]};
export const SUPPLY_ATLAS: AtlasDef = {file:'/assets/mining-supplies.webp',width:1536,height:1024,regions:[
  [94,84,405,379],[669,118,207,299],[1069,74,359,382],
  [62,517,437,420],[550,510,449,411],[1034,523,444,425],
]};
export const CREATURE_ART: Record<CreatureKind,number> = {mole:0,beetle:1,slime:2,bat:3};
export const MINERAL_ART: Record<MineralKind, readonly [AtlasDef, number]> = {
  goldNugget:[BASE_ATLAS,0],goldBlock:[BASE_ATLAS,1],diamond:[BASE_ATLAS,2],cyanCrystal:[BASE_ATLAS,3],
  magentaCrystal:[BASE_ATLAS,4],rock:[BASE_ATLAS,5],dynamite:[BASE_ATLAS,6],trash:[BASE_ATLAS,7],
  relic:[BASE_ATLAS,8],starDust:[BASE_ATLAS,9],amber:[EXTRA_ATLAS,0],fluorite:[EXTRA_ATLAS,1],
  pearl:[EXTRA_ATLAS,2],garnet:[EXTRA_ATLAS,3],fossil:[EXTRA_ATLAS,4],jade:[EXTRA_ATLAS,5],moonstone:[EXTRA_ATLAS,6],starGeode:[EXTRA_ATLAS,7],
  copper:[SUPPLY_ATLAS,0],sapphire:[SUPPLY_ATLAS,1],sunstone:[SUPPLY_ATLAS,2],obsidian:[SUPPLY_ATLAS,3],
};
export const TOOL_ART: Record<ChipId, readonly [AtlasDef,number]> = {
  magnet:[TOOL_ATLAS,0],blast:[TOOL_ATLAS,1],twinHook:[TOOL_ATLAS,2],timeDilation:[TOOL_ATLAS,3],gravityFlip:[TOOL_ATLAS,4],goldFever:[TOOL_ATLAS,5],
  pocketClock:[TOOL_ATLAS,6],seedPouch:[TOOL_ATLAS,7],lantern:[TOOL_ATLAS,8],mossShield:[TOOL_ATLAS,9],surveyLens:[TOOL_ATLAS,10],starElixir:[TOOL_ATLAS,11],
  rescueBell:[SUPPLY_ATLAS,4],ropeShears:[SUPPLY_ATLAS,5],
};
